import React, { useState, useEffect } from 'react';

import './List.scss';

import getTranslate from '../translator.js';
import { LANGUAGE_CODES } from '../constants.js';
import { log as serverLog, error as serverError } from '../utils/serverLogger.js';

const List = ({ rows, isUpdate, locationId, onSelectClicked, onUpdateClicked, onDeleteClicked, onShareClicked, languageCode, locations }) => {
    const [changeItem, setChangeItem] = useState(-1);
    const [title_ko, setTitle_ko] = useState("");
    const [locationMap, setLocationMap] = useState({});

    useEffect(() => {
        // Create location map from props
        const map = {};
        if (locations && Array.isArray(locations)) {
            locations.forEach(location => {
                map[location.id] = location;
            });
        }
        setLocationMap(map);
    }, [locations]);

    const handleChange_ko = (e) => {
        setTitle_ko(e.target.value);
    }

    const translate = async (text) => {
        if (!text) {
            console.error("No text to translate");
            alert("No text to translate.");
            return;
        }
        getTranslate(text)
            .then((result) => {
                setTitle_ko(result);
            })
            .catch((error) => {
                console.error("Translation error:", error);
                alert(`Translation failed: ${error.message || "Unknown error"}`);
            });
    }
    
    function open(url) {
        window.open(url, '_blank');
    }

    const handleSelect = async (item) => {
        let translatedTitle = item.title || "";
        let translatedDescription = item.description || "";

        // Translate title if it's not null
        if (item.title !== null && item.title !== undefined && item.title !== "") {
            try {
                translatedTitle = await getTranslate(item.title);
            } catch (error) {
                console.error("Translation error for title:", error);
                translatedTitle = item.title; // Fallback to original if translation fails
            }
        }

        // Translate description if it's not null
        if (item.description !== null && item.description !== undefined && item.description !== "") {
            try {
                translatedDescription = await getTranslate(item.description);
            } catch (error) {
                console.error("Translation error for description:", error);
                translatedDescription = item.description; // Fallback to original if translation fails
            }
        }

        const selectedData = {
            id: item.id,
            source: item.source || "",
            title: translatedTitle,
            description: translatedDescription,
            link: item.link || "",
            locationId: item.areaId || ""  // Changed from locationId to areaId
        };
        console.log('Selected data in List:', selectedData); // 디버깅을 위한 로그 추가
        onSelectClicked(selectedData);
    };

    const handleUpdate = (item) => {
        setTitle_ko("");
        setChangeItem(item.id);
        // 기존 title_ko가 있다면 입력 필드에 설정
        if (item.title_ko) {
            setTitle_ko(item.title_ko);
        }
    };

    const handleConfirm = async (item) => {
        if (!title_ko) {
            alert("Please enter Korean title");
            return;
        }
        console.log("[confirm] Calling onUpdateClicked", { id: item.id, title: item.title, title_ko });
        serverLog("[confirm] Calling onUpdateClicked", { id: item.id, title: item.title, title_ko });
        const result = await onUpdateClicked(item.id, item.title, title_ko);
        console.log("[confirm] Result", result);
        serverLog("[confirm] Result", result);
        if (result) {
            setChangeItem(-1);
            setTitle_ko("");
        } else {
            console.error("[confirm] Update returned false – check [update] logs above for API/response details.");
            serverError("[confirm] Update returned false – check [update] logs above for API/response details.");
            alert("Update did not succeed. Check the browser console (F12) for [update] and [confirm] logs.");
        }
    };

    const renderChange = (item) => {
        if (changeItem === item.id) {
            return (
                <div className="update_item">
                    <div className="title">{item.title}</div>
                    <div className="translation-group">
                        <div className="translate-button-wrapper">
                            <button onClick={() => translate(item.title)}>translate</button>
                        </div>
                        <textarea 
                            name="title_ko" 
                            onChange={handleChange_ko} 
                            value={title_ko} 
                            placeholder="Korean title"
                            rows="2"
                        />
                    </div>
                    <button onClick={() => handleConfirm(item)}>Confirm</button>
                </div>
            );
        }
        return ""
    }

    return (
        <div className="list_container">
            {rows.map((item) => {
                const location = locationMap[item.locationId];
                return (
                    <div className={isUpdate && item.selected === true ? "list_item selected" : "list_item"}
                        key={item.id}>
                        <div className="content-wrapper">
                            <div className="buttons" onClick={(e) => e.stopPropagation()}>
                                {isUpdate === true ? (
                                    <>
                                        <button onClick={(e) => {
                                            e.stopPropagation();
                                            handleSelect(item);
                                        }}>Select</button>
                                        <button onClick={(e) => {
                                            e.stopPropagation();
                                            handleUpdate(item);
                                        }}>Update</button>
                                    </>
                                ) : null}
                                <button onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteClicked(item.id);
                                }}>Delete</button>
                                {item.title_ko !== null && item.title_ko !== undefined ? (
                                    <button onClick={async (e) => {
                                        e.stopPropagation();
                                        const result = await onShareClicked(locationId, item.source, item.title_ko, "", item.link);
                                        if (result) {
                                            alert("News added successfully in the queue.");
                                        }
                                        console.log(result);
                                    }}>Share</button>
                                ) : null}
                            </div>
                            <div className="clickable-content" onClick={() => open(item.link)}>
                                <div className="source">{item.source}</div>
                                <div className="title">{item.title}</div>
                                {item.title_ko !== null && item.title_ko !== undefined ? 
                                    <div className="title_ko">{item.title_ko}</div> 
                                : null}
                                {location && (
                                    <div className="location">
                                        {languageCode === LANGUAGE_CODES.EN
                                            ? location.name_en
                                            : location.name_ko}
                                    </div>
                                )}
                                <div className="create_at">
                                    {item.createdAt ? item.createdAt.replace(/T/, " ").replace(/.000Z/, "") : ""}
                                </div>
                            </div>
                        </div>
                        {renderChange(item)}
                    </div>
                );
            })}
        </div>
    )
}

export default List;